import React from "react";
import { ConfirmationModal } from "../ConfirmationModal/ConfirmationModal";
import { PaziaButton } from "../../atoms";
import { PaziaModalSize } from "../Modals/PaziaModal";
interface ConfirmDeleteButtonProps {
  dialog: {
    title: string;
    description: string;
  };
  title: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  size?: PaziaModalSize;
  className?: string;
}

export const ConfirmDeleteButton = ({
  title,
  dialog,
  className,
  onCancel,
  onConfirm,
}: ConfirmDeleteButtonProps) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const onCancelHanlder = () => {
    if (onCancel) onCancel();
    setIsOpen(false);
  };

  const onConfirmHandler = () => {
    if (onConfirm) onConfirm();
    setIsOpen(false);
  };

  return (
    <>
      <PaziaButton
        type="danger2"
        title={title}
        onClick={() => setIsOpen(true)}
        className={className}
      />
      <ConfirmationModal
        isOpen={isOpen}
        onCloseRequest={() => setIsOpen(false)}
        {...dialog}
        onCancel={onCancelHanlder}
        onConfirm={onConfirmHandler}
      />
    </>
  );
};
